<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">{{ stepDetails?.name }}</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>


        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i>Save/Forward/Route Config
          </button>
        </ng-container>


      </div>
    </div>
  </div>
  <hr class="my-3" />


  <!-- <app-constitute-committee [id]="stepDetails?.id" [step]="stepDetails" [stepDetails]="stepDetails" [schemeType]="'rev'"
    [getUrl]="'revenue/constitute-committee/'" [postUrl]="'revenue/constitute-committee/'"
    [isDocumentSectionHide]="true"></app-constitute-committee> -->




  <!-- Show 'Not Applicable' when firm capacity is not required -->
  <div *ngIf="firmCapacityRequired === 'no'" class="mb-4">
    <div class="bg-slate-100 border-2 border-slate-300 rounded-lg p-6 text-center">
      <i class="pi pi-info-circle text-4xl text-slate-400 mb-3"></i>
      <h3 class="text-2xl font-bold text-slate-700">Not Applicable</h3>
      <p class="text-slate-600 mt-2">Firm capacity assessment is not required for this proposal.</p>
    </div>
  </div>

  <!-- Show full content when firm capacity is required -->
  <div class="mb-4" *ngIf="firmCapacityRequired === 'yes'">




    <app-upload-document [title]="stepDetails.name+ 'Document'" [isEditable]="stepDetails?.can_edit">
    </app-upload-document>

    <!-- Committee Section -->
    <div class="mt-4">
      <div class="bg-amber-50 border-2 border-gray-300 mb-6 mt-4 rounded transition-all duration-200 hover:shadow-md"
        *ngIf="stepDetails?.can_edit">
        <div
          class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
          <h3 class="text-lg font-semibold flex items-center">
            <span class="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mr-3 text-sm">
              <i class="pi pi-users"></i>
            </span>
            Basic Information
          </h3>
          <i class="pi pi-chevron-down transition-transform duration-200"></i>
        </div>
        <div class="p-6 space-y-4 flex border-t border-slate-100 animate-fade-in">
          <div class="flex flex-col md:flex-row items-center gap-4 w-3/4">
            <label class="block font-medium text-slate-700 mb-2 md:w-1/3">
              Select Committee <span class="text-red-500">*</span>
            </label>
            <div class="w-full md:w-2/3">
              <p-dropdown [options]="schemes" [(ngModel)]="selectedScheme" optionLabel="name"
                styleClass="w-full md:w-2/3" [filter]="true" filterBy="name" placeholder="Select a Committee"
                (onChange)="loadSchemeCommittees($event)" appendTo="body"></p-dropdown>
            </div>
          </div>
          <div class="flex justify-end gap-2 mt-4 w-1/4">
            <button type="button" class="btn btn-outline-primary" (click)="openAddNewCommitteeDialog()">
              <i class="pi pi-plus me-1"></i>Add New Committee
            </button>
            <button type="button" class="btn btn-warning" (click)="addFromExisting()" [disabled]="!selectedScheme">
              <i class="pi pi-plus me-1"></i>Add Committee to Proposal
            </button>
          </div>
        </div>
      </div>

      <ng-container *ngIf="committees?.length">
        <div *ngFor="let committee of committees; let i = index"
          class="w-full mx-auto my-6 shadow-lg rounded-lg bg-white border border-slate-200 transition-all duration-200 hover:shadow-2xl">
          <div
            class="flex flex-col sm:flex-row sm:justify-between sm:items-center bg-gradient-to-r from-blue-100 to-blue-50 p-5 py-2 border-b-2 border-blue-200 rounded-t-lg">
            <div class="flex items-center gap-2">
              <span
                class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-200 text-blue-700 text-xl font-bold shadow-sm">
                <i class="pi pi-users"></i>
              </span>
              <span class="font-bold text-2xl text-slate-800 tracking-tight">{{ committee.name }}</span>
              <span
                class="inline-block ml-3 bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-xs font-semibold"
                *ngIf="committee.members?.length > 0">
                {{ committee.members.length }} Members
              </span>
            </div>
            <div class="mt-4 sm:mt-0 flex gap-2">
              <button *ngIf="stepDetails?.can_edit" (click)="openDeleteDialog(committee, i)" type="button"
                class="inline-flex items-center px-3 py-1.5 border border-red-500 text-red-600 rounded-md hover:bg-red-50 hover:border-red-600 transition">
                <i class="pi pi-trash mr-2"></i> Remove
              </button>
            </div>
          </div>
          <div class="px-3 py-3">
            <div class="rounded-md border border-blue-100 bg-blue-50/50 p-2 mb-4" *ngIf="committee.description">
              <span class="text-sm text-blue-700"><i class="pi pi-info-circle mr-2"></i>{{ committee.description
                }}</span>
            </div>
            <app-data-table [columns]="memberCols" [data]="committee.members" title="Committee Members"
              [isEditable]="stepDetails?.can_edit" [isDeletable]="stepDetails?.can_edit"
              (deleteEventRow)="showDeletePopup($event)" [showSearch]="false" [showActions]="stepDetails?.can_edit"
              [showAddButton]="stepDetails?.can_edit" (onAdd)="openAddCommittee(committee)"
              (editEventRow)="updateCommittemeber($event, committee)">
            </app-data-table>
            <div *ngIf="!committee.members?.length" class="flex flex-col items-center justify-center py-8 opacity-70">
              <i class="pi pi-user-minus text-4xl text-slate-300 mb-2"></i>
              <div class="text-base text-slate-500 font-medium">No members found in this committee.</div>
              <div *ngIf="stepDetails?.can_edit" class="mt-2">
                <button type="button"
                  class="text-blue-600 border border-blue-400 px-4 py-1.5 rounded hover:bg-blue-100 transition"
                  (click)="openAddCommittee(committee)">
                  <i class="pi pi-plus mr-1"></i> Add Member
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Committee Dialogs -->
    <!-- Add Committee Dialog (new committee) -->
    <p-dialog header="Add Committee" [(visible)]="addNewCommitteeDialog" [modal]="true" [style]="{ width: '420px' }"
      [closable]="true" [dismissableMask]="true" [maximizable]="true">
      <form [formGroup]="committeeForm" (ngSubmit)="onCommitteeSubmit()">
        <label class="form-label fw-semibold">Committee Name <span class="text-danger">*</span></label>
        <input type="text" class="form-control mb-1" formControlName="committeeName"
          placeholder="Enter committee name" />
        <div class="text-danger small"
          *ngIf="committeeForm.get('committeeName')?.touched && committeeForm.get('committeeName')?.invalid">
          Name is required.
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="submit" class="btn btn-primary" [disabled]="committeeForm.invalid">
            <i class="pi pi-plus me-1"></i> Add
          </button>
        </div>
      </form>
    </p-dialog>

    <!-- Update Committee Dialog -->
    <p-dialog header="Update Committee" [(visible)]="updateCommitteDialog" [modal]="true" [style]="{ width: '420px' }"
      [closable]="true" [dismissableMask]="true" [maximizable]="true">
      <form [formGroup]="committeeForm" (ngSubmit)="updateSubmit()">
        <label class="form-label fw-semibold">Committee Name</label>
        <input type="text" class="form-control mb-1" formControlName="committeeName"
          placeholder="Enter committee name" />
        <div class="text-danger small"
          *ngIf="committeeForm.get('committeeName')?.touched && committeeForm.get('committeeName')?.invalid">
          Name is required.
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="submit" class="btn btn-primary" [disabled]="committeeForm.invalid || committeeForm.pristine">
            Submit
          </button>
        </div>
      </form>
    </p-dialog>

    <!-- Delete Committee Dialog -->
    <p-dialog header="Delete Committee" [(visible)]="showDeleteConfirmDialog" [modal]="true" [closable]="true"
      [style]="{ width: '400px' }" [maximizable]="true">
      <div class="p-3">
        <p>Are you sure you want to remove the committee <strong>{{ committeeToDelete?.name }}</strong> from the
          proposal?</p>
      </div>
      <ng-template pTemplate="footer">
        <button class="btn btn-sm btn-secondary me-2" (click)="showDeleteConfirmDialog = false">Cancel</button>
        <button class="btn btn-sm btn-danger" (click)="confirmDeleteCommittee()">
          <i class="pi pi-trash me-1"></i> Delete
        </button>
      </ng-template>
    </p-dialog>

    <!-- Update Committee Member -->
    <p-dialog header="Update Member" [(visible)]="editMemberDialog" [modal]="true" [style]="{ width: '50vw' }"
      [closable]="true" [dismissableMask]="true" appendTo="body" [maximizable]="true">
      <form [formGroup]="assignmentForm" (ngSubmit)="onAssignmentUpdateSubmit()">
        <div class="row g-2 p-4">
          <div class="col-12">
            <label class="bg-primary text-white rounded p-2 w-25 d-inline-block mb-2">User <span
                class="text-danger">*</span></label>
            <div class="w-100">
              <div class="d-flex gap-3 mb-3">
                <label class="d-flex align-items-center cursor-pointer">
                  <input type="radio" name="userInputModeEdit" [value]="'dropdown'" [(ngModel)]="userInputMode"
                    (change)="onUserInputModeChange()" class="me-2" [ngModelOptions]="{standalone: true}" />
                  <span class="small">Select from List</span>
                </label>
                <label class="d-flex align-items-center cursor-pointer">
                  <input type="radio" name="userInputModeEdit" [value]="'manual'" [(ngModel)]="userInputMode"
                    (change)="onUserInputModeChange()" class="me-2" [ngModelOptions]="{standalone: true}" />
                  <span class="small">Manual Entry</span>
                </label>
              </div>
              <div *ngIf="userInputMode === 'dropdown'">
                <p-dropdown [options]="userList" optionLabel="first_name" formControlName="user"
                  placeholder="Search/select user" [filter]="true" [showClear]="true" [autoDisplayFirst]="false"
                  filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" appendTo="body"
                  styleClass="w-full">
                  <ng-template pTemplate="selectedItem" let-user>
                    <div *ngIf="user; else noSel1"><small>
                        Directorate <strong>{{ user.unit.name }}</strong> | #<strong>{{ user.loginname }}</strong> |
                        <strong>{{ user.first_name }} {{ user.last_name }}</strong>
                      </small></div>
                    <ng-template #noSel1><span class="text-muted">Choose a user</span></ng-template>
                  </ng-template>
                  <ng-template pTemplate="item" let-user>
                    <div><small>
                        Directorate <strong>{{ user.unit.name }}</strong> | #<strong>{{ user.loginname }}</strong> |
                        <strong>{{ user.first_name }} {{ user.last_name }}</strong> | <strong>{{ user.hrcdf_designation
                          }}</strong>
                      </small></div>
                  </ng-template>
                </p-dropdown>
                <div *ngIf="assignmentForm.get('user')?.touched && assignmentForm.get('user')?.invalid"
                  class="text-danger small mt-1">
                  Please select a user.
                </div>
              </div>
              <div *ngIf="userInputMode === 'manual'">
                <input type="text" class="form-control" formControlName="user_name"
                  placeholder="Enter Designation/Name (e.g. Director, John Doe)" maxlength="200" autocomplete="off" />
                <div *ngIf="assignmentForm.get('user_name')?.touched && assignmentForm.get('user_name')?.invalid"
                  class="text-danger small mt-1">
                  Please enter user name/designation.
                </div>
                <div class="text-muted small mt-1">
                  <i class="pi pi-info-circle me-1"></i>Enter the user's designation or name manually
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 d-flex align-items-center">
            <label class="bg-primary text-white rounded p-2 w-25">Role <span class="text-danger">*</span></label>
            <div class="w-75 ms-2">
              <input type="text" class="form-control" formControlName="role"
                placeholder="e.g. Chairperson, Member Secretary" maxlength="80" autocomplete="off" />
              <div *ngIf="assignmentForm.get('role')?.touched && assignmentForm.get('role')?.invalid"
                class="text-danger small mt-1">
                Role is required.
              </div>
            </div>
          </div>
          <div class="col-12 d-flex align-items-center">
            <label class="bg-primary text-white rounded p-2 w-25">Designation</label>
            <div class="w-75 ms-2">
              <input type="text" class="form-control" formControlName="designation" placeholder="Enter designation"
                maxlength="200" autocomplete="off" />
            </div>
          </div>
          <div class="col-12 d-flex align-items-center">
            <label class="bg-primary text-white rounded p-2 w-25">Contact Details</label>
            <div class="w-75 ms-2">
              <input type="text" class="form-control" formControlName="contact_details"
                placeholder="Enter contact details" maxlength="200" autocomplete="off" />
            </div>
          </div>
          <div class="col-12 d-flex align-items-center">
            <label class="bg-primary text-white rounded p-2 w-25">Mobile No.</label>
            <div class="w-75 ms-2">
              <input type="text" class="form-control" formControlName="mobile_no" placeholder="Enter mobile number"
                maxlength="15" autocomplete="off" />
            </div>
          </div>
          <div class="col-12 d-flex align-items-center">
            <label class="bg-primary text-white rounded p-2 w-25">Email ID</label>
            <div class="w-75 ms-2">
              <input type="email" class="form-control" formControlName="email_id" placeholder="Enter email ID"
                maxlength="100" autocomplete="off" />
            </div>
          </div>
          <div class="col-12 d-flex align-items-center">
            <label class="bg-primary text-white rounded p-2 w-25">Landline No.</label>
            <div class="w-75 ms-2">
              <input type="text" class="form-control" formControlName="landline_no" placeholder="Enter landline number"
                maxlength="15" autocomplete="off" />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="submit" class="btn btn-primary px-4" [disabled]="assignmentForm.invalid">
            <i class="pi pi-check me-2"></i>Update
          </button>
        </div>
      </form>
    </p-dialog>

    <!-- Add Committee Member -->
    <p-dialog header="Add Member" [(visible)]="addCommitteeDialog" [modal]="true" [style]="{ width: '50vw' }"
      [closable]="true" [dismissableMask]="true" appendTo="body" [maximizable]="true">
      <form [formGroup]="assignmentForm" (ngSubmit)="onAssignmentSubmit()">
        <div class="space-y-4 m-3">
          <div class="flex flex-col md:flex-row md:items-center gap-3">
            <label class="block w-full md:w-1/4 bg-blue-600 text-white rounded-md px-3 py-2 font-medium">
              User <span class="text-red-500">*</span>
            </label>
            <div class="w-full md:w-3/4">
              <div class="flex gap-4 mb-3">
                <label class="flex items-center cursor-pointer">
                  <input type="radio" name="userInputMode" [value]="'dropdown'" [(ngModel)]="userInputMode"
                    (change)="onUserInputModeChange()" class="mr-2" [ngModelOptions]="{standalone: true}" />
                  <span class="text-sm font-medium">Select from List</span>
                </label>
                <label class="flex items-center cursor-pointer">
                  <input type="radio" name="userInputMode" [value]="'manual'" [(ngModel)]="userInputMode"
                    (change)="onUserInputModeChange()" class="mr-2" [ngModelOptions]="{standalone: true}" />
                  <span class="text-sm font-medium">Manual Entry</span>
                </label>
              </div>
              <div *ngIf="userInputMode === 'dropdown'">
                <p-dropdown [options]="userList" optionLabel="first_name" formControlName="user"
                  placeholder="Search/select user" [filter]="true" [showClear]="true" [autoDisplayFirst]="false"
                  filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" appendTo="body"
                  styleClass="w-full">
                  <ng-template pTemplate="selectedItem" let-user>
                    <div *ngIf="user; else noSel2" class="text-sm text-gray-700">
                      <span>Directorate <span class="font-semibold">{{ user.unit.name }}</span> | #<span
                          class="font-semibold">{{ user.loginname }}</span> |
                        <span class="font-semibold">{{ user.first_name }} {{ user.last_name }}</span></span>
                    </div>
                    <ng-template #noSel2><span class="text-gray-400">Choose a user</span></ng-template>
                  </ng-template>
                  <ng-template pTemplate="item" let-user>
                    <div class="text-sm">Directorate <span class="font-semibold">{{ user.unit.name }}</span> | #<span
                        class="font-semibold">{{ user.loginname }}</span> |
                      <span class="font-semibold">{{ user.first_name }} {{ user.last_name }}</span> | <span
                        class="font-semibold">{{ user.hrcdf_designation }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
                <div *ngIf="assignmentForm.get('user')?.touched && assignmentForm.get('user')?.invalid"
                  class="text-xs text-red-500 mt-1">
                  Please select a user.
                </div>
              </div>
              <div *ngIf="userInputMode === 'manual'">
                <input type="text"
                  class="form-input w-full border border-gray-300 rounded-md py-2 px-3 focus:border-blue-500 focus:outline-none"
                  formControlName="user_name" placeholder="Enter Designation/Name (e.g. Director, John Doe)"
                  maxlength="200" autocomplete="off" />
                <div *ngIf="assignmentForm.get('user_name')?.touched && assignmentForm.get('user_name')?.invalid"
                  class="text-xs text-red-500 mt-1">
                  Please enter user name/designation.
                </div>
                <div class="text-xs text-gray-500 mt-1">
                  <i class="pi pi-info-circle mr-1"></i>Enter the user's designation or name manually
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-3">
            <label class="block w-full md:w-1/4 bg-blue-600 text-white rounded-md px-3 py-2 font-medium">
              Role <span class="text-red-500">*</span>
            </label>
            <div class="w-full md:w-3/4">
              <input type="text"
                class="form-input w-full border border-gray-300 rounded-md py-2 px-3 focus:border-blue-500 focus:outline-none"
                formControlName="role" placeholder="e.g. Chairperson, Member Secretary" maxlength="80"
                autocomplete="off" />
              <div *ngIf="assignmentForm.get('role')?.touched && assignmentForm.get('role')?.invalid"
                class="text-xs text-red-500 mt-1">
                Role is required.
              </div>
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-3">
            <label class="block w-full md:w-1/4 bg-blue-600 text-white rounded-md px-3 py-2 font-medium">
              Designation
            </label>
            <div class="w-full md:w-3/4">
              <input type="text"
                class="form-input w-full border border-gray-300 rounded-md py-2 px-3 focus:border-blue-500 focus:outline-none"
                formControlName="designation" placeholder="Enter designation" maxlength="200" autocomplete="off" />
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-3">
            <label class="block w-full md:w-1/4 bg-blue-600 text-white rounded-md px-3 py-2 font-medium">
              Contact Details
            </label>
            <div class="w-full md:w-3/4">
              <input type="text"
                class="form-input w-full border border-gray-300 rounded-md py-2 px-3 focus:border-blue-500 focus:outline-none"
                formControlName="contact_details" placeholder="Enter contact details" maxlength="200"
                autocomplete="off" />
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-3">
            <label class="block w-full md:w-1/4 bg-blue-600 text-white rounded-md px-3 py-2 font-medium">
              Mobile No.
            </label>
            <div class="w-full md:w-3/4">
              <input type="text"
                class="form-input w-full border border-gray-300 rounded-md py-2 px-3 focus:border-blue-500 focus:outline-none"
                formControlName="mobile_no" placeholder="Enter mobile number" maxlength="15" autocomplete="off" />
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-3">
            <label class="block w-full md:w-1/4 bg-blue-600 text-white rounded-md px-3 py-2 font-medium">
              Email ID
            </label>
            <div class="w-full md:w-3/4">
              <input type="email"
                class="form-input w-full border border-gray-300 rounded-md py-2 px-3 focus:border-blue-500 focus:outline-none"
                formControlName="email_id" placeholder="Enter email ID" maxlength="100" autocomplete="off" />
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-3">
            <label class="block w-full md:w-1/4 bg-blue-600 text-white rounded-md px-3 py-2 font-medium">
              Landline No.
            </label>
            <div class="w-full md:w-3/4">
              <input type="text"
                class="form-input w-full border border-gray-300 rounded-md py-2 px-3 focus:border-blue-500 focus:outline-none"
                formControlName="landline_no" placeholder="Enter landline number" maxlength="15" autocomplete="off" />
            </div>
          </div>
        </div>
        <div class="flex justify-end mt-6">
          <button type="submit"
            class="inline-flex items-center bg-blue-600 text-white px-5 py-2 rounded-md font-semibold shadow hover:bg-blue-700 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            [disabled]="assignmentForm.invalid">
            <i class="pi pi-plus mr-2"></i>Add
          </button>
        </div>
      </form>
    </p-dialog>

    <!-- Delete Committee Member -->
    <p-dialog header="Delete Member" [(visible)]="deleteMember" [modal]="true" [closable]="true"
      [style]="{ width: '330px' }" appendTo="body" [maximizable]="true">
      <div class="p-3">
        <p>Are you sure you want to remove the committee member from the proposal?</p>
      </div>
      <ng-template pTemplate="footer">
        <button class="btn btn-sm btn-danger" (click)="ConfirmMemberDelete()">
          <i class="pi pi-trash me-1"></i> Delete
        </button>
      </ng-template>
    </p-dialog>

    <!-- Editor form -->
    <form [formGroup]="commentForm" class="proposal-form-container mt-4">
      <div class="form-container">
        <div class="editor-field">
          <p class=" bg-primary text-white p-2 ">
            {{ stepDetails.name }}
          </p>
          <editor [init]="init" formControlName="justification" [disabled]="isEditorDisabled"></editor>
        </div>
      </div>

    </form>
  </div>